import { ErrorCode, TOAST } from 'constant';
// eslint-disable-next-line import/no-cycle
import { toast } from 'layout';
// eslint-disable-next-line import/no-cycle
import { mapError } from '.';

// eslint-disable-next-line import/prefer-default-export
export const catchError = (t, error, navigate) => {
  const errorType = error?.response?.data?.type || error?.response?.data?.code;

  if (errorType === ErrorCode.RESOURCE_FORBIDDEN) {
    navigate('/unauthorized');
  }

  if (errorType.includes('NOT_FOUND')) {
    navigate('/404', {
      state: {
        errorType,
        msg: error?.response?.data?.msg,
      },
    });
  }

  toast(TOAST.ERROR, mapError(t, error));
};
